/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action, computed } from '@ember/object';
import Component from '@glimmer/component';
import ActionCondition from 'cio/app-models/conditions/action';
import { ConditionListEditMessageActionType } from 'cio/utils/action-info';
import { ConditionEditorSubLayout } from 'cio/utils/condition-editor';

interface EditorArgs {
  condition?: any;
  disabled: boolean;
  allowAllVariationsSelection?: boolean;
  allowWildcardSelection?: boolean;
  allowForeignEvent?: boolean;
  allowVariationSelection?: boolean;
  allowInParentWildcardSelection?: boolean;
  variation?: string;
  subLayout?: ConditionEditorSubLayout;
  direction?: string;
  gapSize?: string;
  size?: string;
  dropdownClass?: string;
  marginClass?: string;
  allowSpecificLink: boolean;
  actionTypes?: ConditionListEditMessageActionType[];
  setCondition: (condition: any) => unknown;
}

export default class Editor extends Component<EditorArgs> {
  @action
  onTypeChanged(type: string) {
    this.args.setCondition(
      ActionCondition.create({
        type,
        defaultToWildcard: this.args.allowWildcardSelection,
        isForeignEvent: this.args.allowForeignEvent === true,
      }),
    );
  }

  @computed('args.condition.{type,isForeignEvent}')
  get allowSpecificLink() {
    let allow = this.args.allowSpecificLink;

    if ('compact' === this.args.variation) {
      // in vwb sidebar, we support message specific link for in_app and emails
      // that too only for foreign events (is clicked)
      allow &&= Boolean(this.args.condition.isForeignEvent) && ['in_app', 'email'].includes(this.args.condition.type);
    }

    return allow;
  }
}
